<template>
    <div class="sessionOver">
        <v-dialog
            v-model="showDialog"
            width="500"
        >
            <ValidationProvider
                name="Amount"
                :rules="amountRules"
                v-slot="{ errors, classes }"
            >
                <v-card>
                    <v-card-title>
                        Withdraw Monthly Income
                        <v-icon @click="closeDialog">
                            fas fa-times
                        </v-icon>
                    </v-card-title>
                    <v-card-text>
                            <div class="input-group mb-5" :class="classes">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                    <i class="sprite icon-amount"></i>
                                    </span>
                                </div>
                                <input
                                    type="number"
                                    class="form-control amount"
                                    v-model="withdrawalAmount"
                                    @input="validateAmount"
                                />
                            </div>
                            <small class="form-group--error-message">{{ errors[0] }}</small>

                        <DetailsCard class="mt-30" :cardTitle="cardTitle" :cardContent="cardContent"/>
                    </v-card-text>
                    <v-card-subtitle class="center pt-0">
                        <strong>
                            It may take upto 72 hours to process your withdrawal.
                        </strong>
                    </v-card-subtitle>
                    <v-card-actions>
                        <button
                            class="btn btn-secondary w-150px mb-15"
                            :disabled="(errors.length > 0) || withdrawalAmount < 1 || isButtonDisabled"
                            @click="withdrawMoney"
                        >
                            <span v-if="!isButtonDisabled">
                                Continue
                            </span>
                            <v-progress-circular
                                v-else
                                indeterminate
                                color="amber"
                            ></v-progress-circular>
                        </button>
                    </v-card-actions>
                </v-card>
            </ValidationProvider>
        </v-dialog>
        <v-snackbar v-model="showSnackBar" app timeout="-1">
            {{ snackBarContent }}
            <template v-slot:action="{ attrs }">
                <v-btn
                color="red"
                text
                v-bind="attrs"
                @click="showSnackBar = false"
            >
                Close
            </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import DetailsCard from '@/components/common/detailsCard/bankDetailsCard.vue'

import LenderService from '@/services/lenderService'
import { bus } from '@/main'
export default {
    name: 'WithdrawalDialog',
    components: {
        DetailsCard
    },
    data () {
        return {
            showDialog: false,
            hideCheck: true,
            withdrawalAmount: 0,
            amountRules: 'amountValidation:1000000,1|required',
            cardTitle: 'Bank Account Details',
            cardContent: [],
            snackBarContent: '',
            showSnackBar: false,
            isButtonDisabled: false,
            incomeAmount: 0
        }
    },
    created () {
        bus.$on('withdrawDialog', (data) => {
            this.getBankAccountInfo()
            this.showDialog = true
            const chartDetails = this.$store.getters['dashboard/getChartDetails']
            this.incomeAmount = chartDetails.incomeAmount
            this.withdrawalAmount = this.incomeAmount
            this.amountRules = `amountValidation:${this.incomeAmount},1|required`
        })
    },
    methods: {
        getBankAccountInfo () {
            LenderService.getMaskedBankAccountInfo().then((response) => {
                if (response.status === 200) {
                    const data = response.data
                    this.createCardData(data)
                }
            })
        },
        withdrawMoney () {
            this.isButtonDisabled = true
            const payload = {
                withdrawalAmount: this.withdrawalAmount
            }
            LenderService.withdrawMoney(payload).then((response) => {
                if (response.status === 200) {
                    this.snackBarContent = 'Withdrawal Successful!'
                    this.showSnackBar = true
                    setTimeout(() => {
                        this.showDialog = false
                        location.reload()
                    }, 1)
                } else if (response.status === 400) {
                    this.snackBarContent = 'Withdrawal Failed! Please enter a valid amount.'
                    this.showSnackBar = true
                } else {
                    this.showDialog = false
                    this.snackBarContent = 'Withdrawal Failed!'
                    this.showSnackBar = true
                }
                this.isButtonDisabled = false
            })
        },
        createCardData (accountInfo) {
            this.cardContent = [
                { label: 'Account Holder Name', value: accountInfo.accountName },
                { label: 'Account Number', value: accountInfo.bankAccountNumber },
                { label: 'IFSC', value: accountInfo.ifsc }
            ]
        },
        validateAmount () {
            const amount = this.withdrawalAmount
            const sep = String(12.21).match(/\D/)[0]
            const b = amount.split(sep)
            if (b[1]) {
                if (b[1].length > 2) {
                    this.withdrawalAmount = b[0] + '.' + b[1].slice(0, 2)
                }
            }
        },
        closeDialog () {
            this.showDialog = false
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/sass/components/registration-flow.scss";
@import "@/components/dashboard/dashboard.scss";

.v-card {
    background: white !important;
    color: $primary !important;
}

.v-card__title {
    justify-content: space-between;
}

.v-dialog > .v-card > .v-card__subtitle {
    padding: 6px 24px;
}

.v-dialog > .v-card > .v-card__text {
    color: $primary !important;
    padding: 6px 24px 0px;
}

.v-card__actions{
    justify-content: center;
    @media (min-width: 992px) {
        justify-content: flex-end;
    }
}

.center {
    text-align: center;
}

.fas.fa-times {
    color: #020067;
}

.amount {
  font-size: 18px;
  font-weight: 550 !important;
  letter-spacing: 2px;
}
</style>
